import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';
import { RoutePageProps } from '../../App';
import { MAIN_MENU_ID } from '../../constants/layout';
import { StrapiEnTeteEntity, StrapiPiedPageEntity } from '../../models/layout';
import { Loader } from '../atoms/Loader';
import { ErrorOrSuccessBlock } from '../molecules/ErrorOrSuccessBlock';
import { Footer } from './Footer';
import { Header } from './Header';
import { useViewport } from '../../hooks/useViewport';
import { Seo } from '../atoms/Seo';
import { seoMap } from '../../constants/seo';

type LayoutQuery = {
  enTeteConnecte?: StrapiEnTeteEntity;
  enTete?: StrapiEnTeteEntity;
  piedPage: StrapiPiedPageEntity;
};

export const Layout = ({ locale }: RoutePageProps) => {
  const { i18n } = useTranslation();
  const { isSmallViewport } = useViewport();
  const [isLoading, setIsLoading] = useState(true);
  const { pathname } = useLocation();

  const { error: publicLayoutError, data: publicLayoutData } = useQuery<LayoutQuery>(
    PUBLIC_LAYOUT_QUERY, {
      variables: { locale: locale },
      context: { isPublic: true }
    }
  );

  useEffect(() => {
    i18n?.changeLanguage(locale).catch((err: any) => console.error('i18n.changeLanguage error:', err));
  }, [locale, i18n]);

  useEffect(() => {
    if (publicLayoutData) {
      setIsLoading(false);
    }
  }, [publicLayoutData]);

  if (isLoading) {
    const { title, metaDescription} = seoMap.get(pathname) ?? {};
    return (
      <>
        <Seo title={title} metaDescription={metaDescription} />
        <Loader />
      </>
    );
  }
  if (publicLayoutError) return <ErrorOrSuccessBlock />;

  const enTete = publicLayoutData?.enTete;
  const footer = publicLayoutData?.piedPage;

  return (
    <Box>
      <Header enTete={enTete} locale={locale} />
      {/* laisser le role main - demande rgaa */}
      <Box
        id={`${MAIN_MENU_ID}`}
        component={'main'}
        role="main"
        sx={{ zIndex: 2, pt: isSmallViewport ? '0' : '3rem' }}
      >
        <Outlet/>
      </Box>
      <Footer piedPage={footer} />
    </Box>
  );
};

const FOOTER_QUERY = `
  piedPage(locale: $locale) {
    LiensReseauxSociaux {
      Label
      Lien
    }
    AutresLiens {
      Label
      Lien
    }
  }
`;

const PUBLIC_LAYOUT_QUERY = gql`
query GetLayoutDeconnecte($locale: I18NLocaleCode!) {
  enTete(locale: $locale) {
    LienMenus {
      Label
      Lien
      SousMenus {
        Label
        Lien
      }
    }
  }
  ${FOOTER_QUERY}
}
`;
